export const PERMISSION_NAME = {
  admin: 'Admin',
  ts: 'TS',
  tslic: 'TS LIC',
  tsqa: 'TS QA',
  cebqa: 'CEB QA',
}

export const USER_LEVEL_LIST_BY_PERMISSION = {
  admin: ['cebqa', 'ts', 'tslic', 'tsqa'],
  ts: ['ts'],
  tslic: ['tslic'],
  tsqa: ['tsqa', 'cebqa'],
  cebqa: ['cebqa'],
}

export const PERMISSION_OPTIONS = Object.entries(PERMISSION_NAME).map(([value, label]) => ({ label, value }))
export const USER_LEVEL_OPTIONS = PERMISSION_OPTIONS.slice(1)
